import Vue from 'vue';
import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import { resolvePermissionCheck } from '@/utils/groupPermissions';

const state = {
    orderitem: {},
    orderitem_saving: false,
    orderitem_saving_errors: {},
};

function permissionDeniedError() {
    const message = Vue.prototype.$translate
        ? Vue.prototype.$translate('errors.permission_denied')
        : 'Permission denied';
    return {
        success: false,
        code: 403,
        message,
        details: { non_field_errors: [message] },
    };
}

const mutations = {
    updateOrderItemSaving(state, saving) {
        state.orderitem_saving = saving;
    },
    updateOrderItemSavingErrors(state, errors) {
        state.orderitem_saving_errors = errors;
    },

    updateOrderItem(state, orderitem) {
        state.orderitem = orderitem;
        state.orderitem_saving_errors = {};
    },

};
const actions = {

    async saveOrderItem({ commit, rootGetters, state }, params) {
        const permissions = rootGetters['session/current_user_permissions'];
        const hasAddPermission = resolvePermissionCheck(
            permissions,
            'order.add_orderitem',
        );
        const hasChangePermission = resolvePermissionCheck(
            permissions,
            'order.change_orderitem',
        );

        if (!state.orderitem.id && !hasAddPermission) {
            const error = permissionDeniedError();
            commit('updateOrderItemSavingErrors', error.details);
            throw error;
        }
        if (state.orderitem.id && !hasChangePermission) {
            const error = permissionDeniedError();
            commit('updateOrderItemSavingErrors', error.details);
            throw error;
        }

        commit('updateOrderItemSaving', true);
        commit('updateOrderItemSavingErrors', {});

        let url = '/api/customerorderitems/';
        let method = axios.post;

        if (state.orderitem.id) {
            url = `/api/customerorderitems/${state.orderitem.id}/`;
            method = axios.put;
        }
        try {
            const response = await method(url, state.orderitem);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateOrderItemSavingErrors', error.details);
            throw error;
        } finally {
            commit('updateOrderItemSaving', false);
        }
    },
};


export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
